import { withNaming } from "@bem-react/classname";

const cn = withNaming({
  n: "",
  e: "__",
  m: "--",
  v: "-",
});
export default cn;
